import { createSelector } from '@reduxjs/toolkit';
import { currentOpenChatSelector } from '../currentOpenChatSelector';

export const currentChatActiveReplyMessageSelector = createSelector(
  currentOpenChatSelector,
  currentOpenChat => currentOpenChat?.activeReplyMessage,
);
